import {
  Button,
  Divider,
  Drawer,
  Slider,
  Table,
  Text,
  Title,
} from "@mantine/core";
import { useAppContext } from "../AppContext";
import SearchBlockPlace from "./SearchBlockPlace";
import { useState } from "react";
import { IconRowRemove } from "@tabler/icons-react";

export default function MapConfigDrawer() {
  const {
    mapConfigDrawerOpened,
    closeMapConfigDrawer,
    precision,
    setPrecision,
    blockedLocations,
    setBlockedLocations,
    openSecurityQuestionModal,
    closeAllModals,
    selectedQuestion,
  }: any = useAppContext();

  const [blockedLocationRadius, setBlockedLocationRadius] = useState(100);
  return (
    <Drawer
      opened={mapConfigDrawerOpened}
      onClose={closeMapConfigDrawer}
      title="Map Configuration"
    >
      <Title order={4}>Security question suggestions</Title>
      <Button
        mt="xs"
        onClick={() => {
          closeAllModals();
          closeMapConfigDrawer();
          openSecurityQuestionModal();
        }}
      >
        Open security question suggestions
      </Button>
      {selectedQuestion && (
        <Text mt="xs">
          <strong>Selected question:</strong> {selectedQuestion}
        </Text>
      )}
      <Title order={4} mt="xl">
        Square size / coordinate precision
      </Title>
      <Text size="sm">
        This will increase or decrease the square sizes on the map, resulting in
        more or less options respectively
      </Text>
      <Text>
        Lat: {(1).toFixed(precision)} Lng: : {(1).toFixed(precision)}
      </Text>
      <Slider
        my="xl"
        color="blue"
        min={2}
        max={6}
        step={1}
        marks={[
          { value: 2, label: "2" },
          { value: 3, label: "3" },
          { value: 4, label: "4" },
          { value: 5, label: "5" },
          { value: 6, label: "6" },
        ]}
        defaultValue={4}
        onChange={setPrecision}
      />
      <Title order={4} mt="xl">
        Blocked location radius
      </Title>
      <Text size="sm">
        This value determines the unselectable squares within the given radius
        from the blocked location.
      </Text>
      <Slider
        my="xl"
        labelAlwaysOn
        color="blue"
        min={0}
        max={1600}
        step={10}
        defaultValue={100}
        value={blockedLocationRadius}
        onChange={setBlockedLocationRadius}
        label={(value) => {
          return `${value} meter${value >= 2 || value === 0 ? "s" : ""}`;
        }}
        marks={[
          { value: 0, label: "0" },
          { value: 800, label: "800" },
          { value: 1600, label: "1600" },
        ]}
      />
      <Title order={4} mt="xl">
        Block a location
      </Title>
      <SearchBlockPlace
        mt="xm"
        blockedLocationRadius={blockedLocationRadius}
        setBlockedLocationRadius={setBlockedLocationRadius}
      />
      <Title order={4} mt="xl">
        Blocked locations
      </Title>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Latitude</Table.Th>
            <Table.Th>Longitude</Table.Th>
            <Table.Th>Radius</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {blockedLocations.map((location: any, index: any) => {
            return (
              <Table.Tr>
                <Table.Td>{location.lat.toFixed(precision)}</Table.Td>
                <Table.Td>{location.lng.toFixed(precision)}</Table.Td>
                <Table.Td>{location.radius}</Table.Td>
                <Table.Td>
                  <IconRowRemove
                    cursor="pointer"
                    onClick={() => {
                      blockedLocations.splice(index, 1);
                      setBlockedLocations([...blockedLocations]);
                    }}
                  />
                </Table.Td>
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </Drawer>
  );
}
